import React from "react";
import { FaFacebookF, FaGoogle, FaInstagram } from "react-icons/fa";

const Footer = () => {
  return (
    <footer id="footer" className="bg-[#101826] text-white py-12">
      <div className="container mx-auto px-6 lg:px-12 flex flex-col items-center">
        
        {/* Logo */}
        <div className="mb-6">
          <img src="/assets/images/RSA-logo.png" alt="Client Logo" className="w-40" />
        </div>

        {/* Quick Links in a Row */}
        <nav className="flex flex-wrap justify-center space-x-8 md:space-x-12 text-gray-400 text-lg font-medium">
          <a href="#about" className="hover:text-[#1C9BF8]">About Us</a>
          <a href="#services" className="hover:text-[#1C9BF8]">Services</a>
          <a href="#gallery" className="hover:text-[#1C9BF8]">Gallery</a>
          <a href="#contact" className="hover:text-[#1C9BF8]">Contact</a>
        </nav>

        {/* Footer Bottom */}
        <div className="mt-8 w-full flex flex-col items-center border-t border-gray-600 pt-4">
          <p className="text-gray-400 text-sm">© {new Date().getFullYear()} Ramon’s Supreme Autos. All rights reserved.</p>
          <p className="text-gray-400 text-sm">Designed & Built by<a href="https://www.mdotl.com" target="_blank" rel="noopener noreferrer"> M.L Digital.</a></p>
          <div className="flex space-x-4 mt-2">
            <a href="https://www.facebook.com/people/Ramons-Supreme-Automotives/61552360670729/" target="_blank" rel="noopener noreferrer" className="hover:text-[#1C9BF8]"><FaFacebookF /></a>
            <a href="https://www.instagram.com/ramonsupremeauto?igsh=OWlubmtpazZ6a29o" target="_blank" rel="noopener noreferrer" className="hover:text-[#1C9BF8]"><FaInstagram /></a>
            <a href="https://maps.app.goo.gl/bsQDsizZAkpLFqxz6" target="_blank" rel="noopener noreferrer" className="hover:text-[#1C9BF8]"><FaGoogle /></a>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
